// ContactInput — naam + telefoon + mail.

import React from 'react';
import { Stack, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ContactInput({ value, onChange, disabled }) {
    const { t } = useTranslation();
    const v = value || { name: '', phone: '', email: '' };
    const update = (key) => (ev) => onChange({ ...v, [key]: ev.target.value });

    return (
        <Stack spacing={1.5}>
            <TextField
                label={t('input.contact.name')}
                value={v.name}
                onChange={update('name')}
                autoComplete="name"
                disabled={disabled}
            />
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
                <TextField
                    label={t('input.contact.phone')}
                    value={v.phone}
                    onChange={update('phone')}
                    type="tel"
                    inputMode="tel"
                    autoComplete="tel"
                    disabled={disabled}
                />
                <TextField
                    label={t('input.contact.email')}
                    value={v.email}
                    onChange={update('email')}
                    type="email"
                    inputMode="email"
                    autoComplete="email"
                    disabled={disabled}
                />
            </Stack>
        </Stack>
    );
}
